import { reactive } from 'vue';
import moment from 'moment';
import { present } from '@/shared/utils/typescript';
import VehicleData from '@/vehicle/models/VehicleData';
import DossierVehicleClient from '../client/DossierVehicleClient';
import Dossier from '../models/Dossier';
import DossierVehicle from '../models/DossierVehicle';
import Location from '@/vehicle/models/Location';
import AuthService from '@/general/services/AuthService';

class DossierVehicleService {
  private current: DossierVehicle | null = null;

  getCurrent(): DossierVehicle {
    return present(this.current, 'no current dossier vehicle');
  }

  async loadCurrent(dossier: Dossier): Promise<DossierVehicle> {
    this.current = await DossierVehicleClient.loadByDossier(dossier);
    return this.current;
  }

  async update(data: VehicleData, dossierVehicle: DossierVehicle): Promise<void> {
    const vehicle = dossierVehicle.vehicle;
    const location = vehicle.location?.isEqualTo(data.position, data.locationDescription)
      ? vehicle.location
      : Location.create(data.locationDescription, data.position, moment(), AuthService.getCurrentUser());

    await DossierVehicleClient.update(dossierVehicle.dossier.id, data);
    vehicle.update(data, location);
  }
}

export default reactive(new DossierVehicleService());
